import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import history from "../../auth/history";
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { resetMiscData, setBankLogoList, setDeviceInfo, setErrMsg, setLoginTimestamp, setResetPasswordLoader } from "../../redux/misc-data/misc-data.action";
import '../BillPayComponent/billPayy.css';
import tokenErrorHandler from "../tokenErrorHandler";
import DeviceDetails from "./DeviceDetails";
import swal from "sweetalert";
const httpClient = axios.create();


class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enteredOtp: '',
            userId: '',
            enteredPassword: '',
            confirmedPassword: '',
            message: '',
            resetPartner: '',
            otpErrMsg: '',
            userIdErrMsg: '',
            enteredPasswordErrMsg: '',
            confirmPsswordErrMsg: '',
            errMsg: '',
            deviceResponse:''
        }
    }

    componentDidMount() {
        store.dispatch(setErrMsg(''));
        store.dispatch(setResetPasswordLoader(''));

        var resetPasswordRedirectPartner = process.env.REACT_APP_PARTNER;

        this.setState({
            resetPartner: resetPasswordRedirectPartner
        })

        navigator.geolocation.getCurrentPosition(function (position) {

            console.log("Latitude is :", position.coords.latitude);

            console.log("Longitude is :", position.coords.longitude);

            const deviceInfo = DeviceDetails.fetchDeviceInfo(position.coords.latitude,
                position.coords.longitude);
            deviceInfo.then((deviceResponse) => {
                store.dispatch(setDeviceInfo(deviceResponse));
    
                console.log('deviceInfo...' + JSON.stringify(deviceResponse));
                
            })
        });

    }
    componentWillUnmount() {
    }

    checkValidation() {
        {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailId)) {
                return (true)
            }
            alert("You have entered an invalid email address!")
            return (false)
        }
    }


    enterUserId = (e) => {
        e.preventDefault();
        store.dispatch(setErrMsg(''));

        this.setState({
            userId: e.target.value,
            userIdErrMsg: ''
        })
    }
    enterPassword = (e) => {
        e.preventDefault();
        store.dispatch(setErrMsg(''));

        this.setState({
            enteredPassword: e.target.value,
            enteredPasswordErrMsg: ''
        })
    }
    enterPassword2 = (e) => {
        e.preventDefault();
        store.dispatch(setErrMsg(''));

        this.setState({
            confirmedPassword: e.target.value,
            confirmPsswordErrMsg: ''
        })
    }
    enterOtp = (e) => {
        e.preventDefault();
        store.dispatch(setErrMsg(''));

        this.setState({
            enteredOtp: e.target.value,
            otpErrMsg: ''
        })
    }


    resetPassword = (event) => {
        event.preventDefault();
        store.dispatch(setErrMsg(''));
        store.dispatch(setResetPasswordLoader('started'));

        this.setState({
            errMsg: '',
            userIdErrMsg: '',
            enteredPasswordErrMsg: '',
            confirmPsswordErrMsg: '',
            otpErrMsg: '',

        })


        //service for rest password and back to login page
        if (this.state.enteredOtp != '' &&
            this.state.userId != '' &&
            this.state.enteredPassword != '' &&
            this.state.confirmedPassword != '' &&
            (this.state.enteredPassword == this.state.confirmedPassword)) {
            var url = '/api/v1/retailer/reset';
            var partner = process.env.REACT_APP_PARTNER;
            var requesterId = process.env.REACT_APP_REQUESTERID;
            const requestHeader = {
                msgType: "AUTHORIZE_WHITELABEL_USER",
                service: partner == 'emitra' ? "EMITRA" : partner == 'cms' ? 'CMS' :
                    partner == 'finxpay' && 'FINXPAY',
                src: "reset-password",
                dst: "login",
                channel: "WHITELABEL",
                requesterId: requesterId,
                requestId: uuidv4(),//filled by the 3rd party requester
                time: moment().utc(),
                traceId: uuidv4(),
            }
            var user = {
                role: 'RETAILER',
                id: this.state.userId.trim()
            }

            var credentials = {
                user: user,
                pass: this.state.enteredPassword.trim(),
                txnPass: this.state.enteredPassword.trim()
            }

            var otpDetails = this.props.savedOtpDetails;

            otpDetails.otp = this.state.enteredOtp;

            if(this.props.deviceInfo!='' &&
            this.props.deviceInfo!=undefined &&
            this.props.deviceInfo!=null){
              
                var request = {
                    header: requestHeader,
                    device: this.props.deviceInfo,
                    credentials: credentials,
                    otpDetails: otpDetails
                }

                httpClient.post(url, request
                ).then((response) => {
                    console.log('reset password response' + JSON.stringify(response.data));

                    if (response.data.response.msg == 'SUCCESS') {
                        store.dispatch(setResetPasswordLoader(''));
                        //swal for rest done
                        swal({
                            title: "Success!",
                            text: "Reset password done successfully..",
                            icon: "success",
                            button: true,
                            dangerMode: false,
                        }).then(() => {
                            history.push('/' + process.env.REACT_APP_PARTNER + '-login');
                            history.go();
                        });

                    } else {
                        store.dispatch(setResetPasswordLoader(''));
                        store.dispatch(setErrMsg(response.data.response.displayMsg))
                    }
                }).catch(error => {
                    store.dispatch(setResetPasswordLoader(''));
                    if (error.message.includes("401")) {
                        tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                    } else {

                        store.dispatch(setErrMsg('Something went wrong!'))
                    }

                });
            }else{
                navigator.geolocation.getCurrentPosition(function (position) {

                    console.log("Latitude is :", position.coords.latitude);
    
                    console.log("Longitude is :", position.coords.longitude);
    
                    const deviceInfo = DeviceDetails.fetchDeviceInfo(position.coords.latitude,
                        position.coords.longitude);
                    deviceInfo.then((deviceResponse) => {
                        store.dispatch(setDeviceInfo(deviceResponse));
    
                        console.log('deviceInfo...' + JSON.stringify(deviceResponse));
    
                        var request = {
                            header: requestHeader,
                            device: deviceResponse,
                            credentials: credentials,
                            otpDetails: otpDetails
                        }
    
                        httpClient.post(url, request
                        ).then((response) => {
                            console.log('reset password response' + JSON.stringify(response.data));
    
                            if (response.data.response.msg == 'SUCCESS') {
                                store.dispatch(setResetPasswordLoader(''));
                                //swal for rest done
                                swal({
                                    title: "Success!",
                                    text: "Reset password done successfully..",
                                    icon: "success",
                                    button: true,
                                    dangerMode: false,
                                }).then(() => {
                                    history.push('/' + process.env.REACT_APP_PARTNER + '-login');
                                    history.go();
                                });
    
                            } else {
                                store.dispatch(setResetPasswordLoader(''));
                                store.dispatch(setErrMsg(response.data.response.displayMsg))
                            }
                        }).catch(error => {
                            store.dispatch(setResetPasswordLoader(''));
                            if (error.message.includes("401")) {
                                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                            } else {
    
                                store.dispatch(setErrMsg('Something went wrong!'))
                            }
    
                        });
                    })
                });

            }
           
        } else {

            store.dispatch(setResetPasswordLoader(''));
            if (this.state.enteredOtp == '') {
                this.setState({
                    otpErrMsg: 'Please enter OTP'
                })
            }

            if (this.state.userId == '') {
                this.setState({
                    userIdErrMsg: 'Please enter User Id'
                })
            }

            if (this.state.enteredPassword == '') {
                this.setState({
                    enteredPasswordErrMsg: 'Please enter Password'
                })
            }

            if (this.state.confirmedPassword == '') {
                this.setState({
                    confirmPsswordErrMsg: 'Please enter Password'
                })
            }


            if (this.state.confirmedPassword != '' &&
                this.state.enteredPassword != '' &&
                this.state.confirmedPassword != this.state.enteredPassword) {
                this.setState({
                    confirmPsswordErrMsg: 'Password not matched'
                })
            }

        }


    }


    generateOtp = (event) => {

        event.preventDefault();

        store.dispatch(setErrMsg(''));

        this.setState({
            errMsg: ''
        })
        if (this.state.userId != '') {
            var url = '/api/v1/retailer/reset/' + this.state.userId;
            httpClient.get(url,
            ).then((response) => {
                console.log('reset otp response' + JSON.stringify(response.data));

                if (response.data.response.msg == 'SUCCESS') {

                } else {
                    this.setState({
                        errMsg: response.data.displayMsg
                    })
                }
            }).catch(error => {
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {
                    this.setState({
                        errMsg: 'Something went wrong!'
                    })
                }
                console.log(error.message);
            });
        } else {
            this.setState({
                errMsg: 'Please enter user Id'
            })
        }
    }




    render() {

        return (
            <div>
                <div class="login-container">
                    <div class="container-fluid">
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                                <div class="login-box">
                                    <div class="login-head">


                                        {this.state.resetPartner == 'cms' &&

                                            <center>
                                                <div class='cms-logo'></div>
                                            </center>
                                        }
                                        {this.state.resetPartner == 'finxpay' &&
                                            <img src="images/finxpay.png" alt="finXpay" class="img-fluid"></img>
                                        }

                                        <p>Reset Password</p>
                                    </div>

                                    <div class="resetForm" id="amtbox1">
                                        <center>
                                            <form onSubmit={this.resetPassword}>
                                                <div class="form-floating">
                                                    <input type="text" class="form-control" id="emailid" placeholder="User ID"
                                                        onChange={this.enterUserId} />
                                                    <label for="emailid">User ID</label>
                                                    {this.state.userIdErrMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.userIdErrMsg}
                                                        </div>
                                                    }
                                                </div>
                                                <br />


                                                <div class="form-floating">
                                                    <input type="password" class="form-control" id="pass" placeholder="Password"
                                                        onChange={this.enterPassword} />
                                                    <label for="pass">Enter Password</label>
                                                    {this.state.enteredPasswordErrMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.enteredPasswordErrMsg}
                                                        </div>
                                                    }
                                                </div>
                                                <br />
                                                <div class="form-floating">
                                                    <input type="password" class="form-control" id="pass" placeholder="Password"
                                                        onChange={this.enterPassword2} />
                                                    <label for="pass">Confirm Password</label>
                                                    {this.state.confirmPsswordErrMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.confirmPsswordErrMsg}
                                                        </div>
                                                    }
                                                </div>
                                                <br />


                                                <div class="form-floating">
                                                    <input type="password" class="form-control" id="pass" placeholder="Password"
                                                        onChange={this.enterOtp} />
                                                    <label for="amt">OTP</label>

                                                    {this.state.otpErrMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.otpErrMsg}
                                                        </div>
                                                    }
                                                </div>

                                                <div class="login-form">
                                                    <button class="button" type="submit"
                                                        disabled={this.props.resetPasswordLoader == 'started' ? true : false}>Reset</button>
                                                    {this.props.resetPasswordLoader == 'started' &&
                                                        <div class='valid-success'>
                                                            Please wait...
                                                        </div>}
                                                    {this.props.errMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.props.errMsg}
                                                        </div>}
                                                </div>

                                            </form>
                                        </center>
                                    </div>
                                    <div class="login-form">

                                        <div class="md-form">
                                            {/* <img src="images/captcha.jpg" alt="captcha" class="img-fluid"/> */}

                                        </div>
                                        <p><a href={"/reset-otp"}>Back to Resend OTP?</a></p>

                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="logcopy">Copyright &copy; 2022 All rights reserved. <br />Powered by <a href="https://www.finxpay.co.in/" target="_blank">Uvva Infotech Pvt. Ltd.</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}


const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { savedOtpDetails, phone, errMsg, callBackUrl, resetPasswordLoader ,
        deviceInfo} }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, savedOtpDetails, phone,
    errMsg, callBackUrl, resetPasswordLoader,deviceInfo
});

export default connect(mapStateToProps, null)(ResetPassword);
